import { BottomNav } from "./BottomNav";
import { resolveBrand, isBrandedNarrow } from "../lib/brand";

export const PageWrapper = ({ children, showNav = true, className = "" }) => {
  // Feb 2026 — on branded hosts (soulumo.app, oml, etc) hide the
  // Reclaim bottom nav so the app never leaks Reclaim chrome.
  const brandNarrow = isBrandedNarrow(resolveBrand());
  const navVisible = showNav && !brandNarrow;
  return (
    <div className={`min-h-screen bg-[#FAF9F7] ${navVisible ? "pb-28" : ""} ${className}`}>
      <div className="animate-fade-in">
        {children}
      </div>
      {navVisible && <BottomNav />}
    </div>
  );
};
